<h3 mat-dialog-title>Generate Report</h3>

<mat-dialog-content>

    <div class="example-container">
        
            <div class="format-choice">
                <label>Format: </label>
                <mat-radio-group [(ngModel)]="selectedFormat">
                    <mat-radio-button *ngFor="let item of formatList" [value]="item.value">
                        {{ item.label }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="div-progress">
                <mat-progress-bar mode="determinate" [value]="percent"></mat-progress-bar>
            </div>
            
            <div class="div-info">
                <label>{{stage}}</label>
            </div>

    </div>

</mat-dialog-content>

<mat-dialog-actions>

    <span class="example-spacer"></span>
    
    <button mat-button extended (click)="start()" cdkFocusInitial>
        Generate
    </button>
    
    <button mat-button (click)="cancel()">Cancel</button>

</mat-dialog-actions>
